export const marketplace = action => {
  return {
    data: action
  };
};